import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { Shell, getB2BConfig, getB2CConfig } from '../..';
export let msalInstance;
export function initializeMsal({ shell = Shell.Business }) {
    //to initialize on demand after config is loaded
    const config = shell === Shell.Business ? getB2BConfig() : getB2CConfig();
    if (msalInstance && config?.auth?.clientId && 'not set' !== config.auth.clientId) {
        return;
    }
    msalInstance = new PublicClientApplication(config);
    msalInstance.enableAccountStorageEvents();
    msalInstance.addEventCallback(event => {
        if (event.eventType === EventType.LOGIN_SUCCESS) {
            const authResult = event.payload;
            const account = authResult.account;
            msalInstance.setActiveAccount(account);
        }
        else if (event.eventType === EventType.ACCOUNT_REMOVED) {
            window.location.reload();
        }
    });
    const accounts = msalInstance.getAllAccounts();
    if (accounts !== undefined) {
        if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
        }
    }
    return msalInstance;
}
